import styled from 'styled-components';

export const SettingsSkeletonStyled = styled.div`
  .ant-skeleton-element {
    width: 250px;

    .ant-skeleton-input,
    .ant-skeleton-button {
      width: 100%;
    }
  }
`;

export const SettingsFormItemSkeletonStyled = styled.div`
  width: 48%;

  .ant-skeleton {
    &:first-child {
      width: 50%;
    }

    &:not(:first-child) {
      width: 100%;
    }
  }
`;
